import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { ContractPaymentRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_CONTRACT_PAYMENTS } = ServerConstants;
const {
  REQUEST_CONTRACT_PAYMENT_LIST_ID,
  REQUEST_CONTRACT_PAYMENT_OPTIONS_ID,
  REQUEST_CONTRACT_PAYMENT_CREATE_ID,
  REQUEST_CONTRACT_PAYMENT_DELETE_ID,
} = ServiceConstants;

export async function getContractPayments(contractId: number) {
  const requestId = REQUEST_CONTRACT_PAYMENT_LIST_ID + contractId;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(API_V1_CONTRACT_PAYMENTS, {
      params: { contractId },
    });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getContractPayments, [contractId], requestId);
  }
}

export async function getContractPaymentOptions() {
  const requestId = REQUEST_CONTRACT_PAYMENT_OPTIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CONTRACT_PAYMENTS}/options`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getContractPaymentOptions, [], requestId);
  }
}

export async function createContractPayment(data: ContractPaymentRequest) {
  const requestId = REQUEST_CONTRACT_PAYMENT_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_CONTRACT_PAYMENTS, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, createContractPayment, [data], requestId);
  }
}

export async function deleteContractPayment(id: number) {
  const requestId = REQUEST_CONTRACT_PAYMENT_DELETE_ID + id;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.delete(`${API_V1_CONTRACT_PAYMENTS}/${id}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, deleteContractPayment, [id], requestId);
  }
}
